module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-289830d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/post/index.vue
// module id = 469
// module chunks = 1